import { render, staticRenderFns } from "./FarmerShow.vue?vue&type=template&id=9e49f706&scoped=true"
import script from "./FarmerShow.vue?vue&type=script&lang=js"
export * from "./FarmerShow.vue?vue&type=script&lang=js"
import style0 from "./FarmerShow.vue?vue&type=style&index=0&id=9e49f706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e49f706",
  null
  
)

export default component.exports